import React, { Component } from 'react';
import { MenuItem, Menu, Icon } from '@material-ui/core';

export default class MoreOptionsMenu extends Component {
    render() {
        const { menuAnchor, closeMenu, deleteCategory, editCategory } = this.props;
        return (
            <Menu
                id="simple-menu"
                anchorEl={menuAnchor}
                keepMounted
                open={Boolean(menuAnchor)}
                onClose={closeMenu}>
                <MenuItem onClick={() => {
                    editCategory();
                    closeMenu();
                }}><Icon style={{ marginRight: 10 }}>edit</Icon> Edit category</MenuItem>
                <MenuItem onClick={deleteCategory}><Icon style={{ marginRight: 10 }}>delete</Icon> Delete category</MenuItem>
            </Menu>
        )
    }
}